import { UNIT } from '../../../constant/unit'
import { defineMessages } from 'react-intl'

const labels = defineMessages({
  feet: {
    id: 'HeightUnit.feet',
    defaultMessage: 'ft',
    description: 'The label used for the feet unit.'
  },
  centimeters: {
    id: 'HeightUnit.centimeters',
    defaultMessage: 'cm',
    description: 'The label used for the centimeters unit.'
  }
})

const labelsWithValue = defineMessages({
  feet: {
    id: 'HeightUnit.feetWithValue',
    defaultMessage: '{value} ft, {secondValue} in',
    description: 'The label used for the feet unit.'
  },
  meters: {
    id: 'HeightUnit.metersWithValue',
    defaultMessage: '{value} m',
    description: 'The label used for the meter unit.'
  }
})

const HEIGHT_UNIT_MESSAGE = {
  [UNIT.IMPERIAL]: labels.feet,
  [UNIT.METRIC]: labels.centimeters
}

const HEIGHT_UNIT_MESSAGE_WITH_VALUE = {
  [UNIT.IMPERIAL]: labelsWithValue.feet,
  [UNIT.METRIC]: labelsWithValue.meters
}

const HEIGHT_UNIT_METER_PER_FOOT = 0.3048

const HEIGHT_MIN_IMPERIAL_HEIGHT = 1
const HEIGHT_MAX_IMPERIAL_HEIGHT = 9
const HEIGHT_MIN_METRIC_HEIGHT = 0.5
const HEIGHT_MAX_METRIC_HEIGHT = 3

export {
  HEIGHT_UNIT_MESSAGE,
  HEIGHT_UNIT_MESSAGE_WITH_VALUE,
  HEIGHT_UNIT_METER_PER_FOOT,
  HEIGHT_MIN_IMPERIAL_HEIGHT,
  HEIGHT_MAX_IMPERIAL_HEIGHT,
  HEIGHT_MIN_METRIC_HEIGHT,
  HEIGHT_MAX_METRIC_HEIGHT
}
